namespace $ {
	if( $mol_dom.document ) $giper_baza_yard.masters_default.push( $mol_dom.document.location.origin + '/' )
}
